import { MouseEventHandler } from "react";
import { Card, CardActionArea, Skeleton, Stack, Typography, useTheme } from "@mui/material";

interface ScenarioResultSmallProps {
  title?: string;
  selected?: boolean;
  loading?: boolean;
  onClick?: () => void;
  onMouseEnter?: MouseEventHandler<HTMLElement>;
}

const ScenarioResultSmall = ({ title, selected, onClick, onMouseEnter, loading = false }: ScenarioResultSmallProps) => {
  const theme = useTheme();

  return (
    <Card
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      elevation={0}
      sx={{
        borderRadius: 10,
        cornerShape: "round",
        backdropFilter: `blur(${theme.spacing(2)})`,
        backgroundColor: `${theme.palette.dsSurface.v200}90`,
        border: selected ? `2px solid ${theme.palette.dsPrimary.v300}` : `1px solid ${theme.palette.dsBase.v200}10`,
        transition: "border-color 0.2s ease-in-out, background 0.2s ease-in-out",
        width: "fit-content",
        flexShrink: 0,
      }}
    >
      <CardActionArea sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Stack direction="row" padding={theme.spacing(1.5, 5)} justifyContent="center" alignItems="center" minWidth={theme.spacing(10.5)}>
          <Typography variant={"textLg500"} color={selected ? "text.primary" : "text.secondary"} sx={{ textAlign: "center" }}>
            {loading ? <Skeleton variant="text" width={80} height={24} /> : title}
          </Typography>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export default ScenarioResultSmall;
